import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EsopRoutingModule } from './esop-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';


@NgModule({
  declarations: [EsopRoutingModule.components],
  imports: [
    CommonModule,
    EsopRoutingModule,
    SharedModule
  ]
})
export class EsopModule { }
